<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
};
</script>

<style>
* {
  box-sizing: border-box;
}
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #fff;
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  touch-action: manipulation;
  -ms-text-size-adjust: none;
  font-size: 14px;
}

#app {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/App.vue